import { metaAI } from "neql"
import { useCallback } from "react"
import { useNeqlContextProvider } from "./useNeqlContextProvider"

export const useAIModelDeployment = (
    appID: string
): [(modelIds: string[]) => Promise<void>, boolean] => {
    const clientForApp = useNeqlContextProvider("metaAIApp", appID)
    const [startDeployment, { loading: isDeploying }] =
        metaAI.useStartDeploymentMutation({ client: clientForApp })
    const [requestPrediction, { loading: requestingPrediction }] =
        metaAI.useRequestPredictionOfAppMutation({ client: clientForApp })

    const onRequestPrediction = useCallback(
        async (modelIds: string[]) => {
            await Promise.all(
                modelIds.map(modelId =>
                    startDeployment({
                        variables: {
                            modelId
                        }
                    })
                )
            )
            await requestPrediction({ variables: { appId: appID } })
        },
        [appID, requestPrediction, startDeployment]
    )

    return [onRequestPrediction, isDeploying || requestingPrediction]
}
